module.exports = __webpack_public_path__ + "static/media/signup_login.6275e1f6.svg";